import {subDays} from "date-fns";
<template>
    <gj-modal
            v-bind="$attrs"
            v-on="$listeners"
            size="auto"
            :show-overflow="false"
            :visible.sync="modalVisible"
            :confirmLoading="confirmLoading"
            @close="cancel"
         >
        <span slot="header">分摊详情</span>
        <el-form
                slot="content"
                inline
                :model="form"
                ref="form">
            <el-row >
                <el-form-item prop="countryData">
                    <gj-country-server-select v-model="form.countryData"/>
                </el-form-item>
                <el-form-item>
                    <gj-select-input
                            :value="form.keyword"
                            :options="[
                                {id: 'msku', text: 'MSKU',},
                                {id: 'sku', text: 'SKU',},
                                {id: 'asin', text: 'ASIN',},
                                {id: 'fatherAsin', text: '父ASIN',},
                            ]"
                    >
                    </gj-select-input>
                </el-form-item>
                <el-form-item>
                    <gj-button type="primary" @click="handleFetchCost">查询</gj-button>
                    <gj-button type="default" @click="handleRestForm">重置</gj-button>
                </el-form-item>

            </el-row>
            <gj-table ref="gjTable"
                      :loading="loading"
                      index-text="排名"
                      :data="tableData"
                      :columns="columns"
                      :adapt-height="false"
                      :height="568"
            >
            <!-- :pagination="pagination" -->
                <template v-slot:listingInfo="{ row }">
                    <div class="text-ellipsis-1">
                        {{row.title}}
                    </div>
                    <el-row>
                        <el-col :span="12">{{row.asin}}</el-col>
                        <el-col :span="12">{{row.msku}}</el-col>
                    </el-row>
                </template>
                <template v-slot:sku="{ row }">
                    <div>
                        <gj-tooltip
                                :text-line="1"
                                :content="row.productName">
                            {{row.productName | defaultShow}}
                        </gj-tooltip>
                    </div>
                    <div>{{row.sku | defaultShow}}</div>
                </template>
                <template v-slot:salesMoney="{ row }">
                    <span>{{ row.currencySymbol }}{{ row.salesMoney | defaultShow }}</span>
                </template>
                <template v-slot:dayShareMoney="{ row }">
                  <template v-if="$permission('financialMonthCost:update')">
                    <gj-input
                        v-model="row.dayShareMoney"
                        placeholder="采购成本"
                        width="120px"
                        v-number.toFixed4
                    >
                      <template #prefix>
                        $
                      </template>
                    </gj-input>
                  </template>
                  <template v-else>
                    <span>{{ row.currencySymbol }}{{ row.dayShareMoney | defaultShow }}</span>
                  </template>
                </template>
            </gj-table>
        </el-form>

    </gj-modal>
</template>

<script>
    import {
        postFeeShareDetail
    } from '@/api/finance'
    import {
        modalMixIn,
        queryMixin,
        isMeaningfulMixin
    } from "@/minxins";
    import {mapGetters} from "vuex";
    export default {
        name: "cost-average-detail-modal",
        mixins: [modalMixIn, queryMixin, isMeaningfulMixin],
        props: {
            rowItem: {
                type: Object
            },
            formItem: {
                type: Object
            }
        },
        data () {
            return {
                form: {
                    countryData: {
                        countryIds: [],
                        marketIds: []
                    },
                    feeShareMonth: '',
                    keyword: {
                        key: 'msku',
                        value: ''
                    },

                },
                tableData: [],
                columns: [
                    {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '120px', options: () => this.marketOption},
                    {id: 'picture', header: '图片', field: 'picture:picture', minWidth: '60px',},
                    {id: 'listingInfo', header: '商品标题/ASIN/MSKU', field: 'slot:listingInfo', minWidth: '300px',},
                    {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', default: true, sortable: true, sortBy: 'sku'},
                    {id: 'fatherAsin', header: '父ASIN', field: 'fatherAsin', minWidth: '120px'},
                    {id: 'feeShareDate', header: '日期', field: 'feeShareDate', minWidth: '120px'},
                    {id: 'salesMoney', header: '销售额', field: 'slot:salesMoney', minWidth: '120px', align: 'right'},
                    {id: 'dayShareMoney', header: '每日分摊金额', field: 'slot:dayShareMoney', minWidth: '120px', align: 'right'},
                    ]
            }
        },
        created () {
            this.initParams()
            this.$gjQuery()
        },
        computed: {
            ...mapGetters({
                marketOption: 'marketOption'
            }),
        },
        methods: {
            /**
             * 查询
             */
            handleFetchCost () {
                this.$gjNoticeQuery()
            },
            /**
             * 重置
             */
            handleRestForm () {
                this.form.countryData = {
                    countryIds: [],
                    marketIds: []
                }

                this.form.keyword = {
                    key: 'msku',
                    value: ''
                }
            },
            /**
             * 构建查询参数
             */
            initParams() {
                if (this.formItem) {
                    const { countryData = {}, feeShareMonth = '' } = this.formItem
                    const { countryIds = [], marketIds = [] } = countryData
                    this.form.countryData = { countryIds, marketIds }
                    this.form.feeShareMonth = feeShareMonth
                }
            },
            $gjQuery() {
                if (!this.isMeaningful(this.rowItem)) {
                    return;
                }
                const { keyword, feeShareMonth = '' } = this.form
                const { countryData = {}} = this.form.countryData
                const { countryIds = [], marketIds = [] } = countryData
                // 构造查询参数
                const params = {
                    ...this.rowItem,
                    keyword: keyword.value,
                    queryType: keyword.key,
                    countryIds,
                    marketIds,
                    feeShareMonth
                };
                // 查询
                this.loading = true;
                this.postFeeShareDetail(params)
            },
            /**
             * 分摊详情列表
             */
            postFeeShareDetail (params = {}) {
                postFeeShareDetail(params).then((res = []) => {
                    this.tableData = res
                }).complete(() => this.loading = false)
            }
        }
    }
</script>

<style scoped>

</style>
